import styles from "./AccountingGroupForm.module.scss"

import type { UseFormRegisterReturn } from "react-hook-form"

type Props = {
	register: UseFormRegisterReturn
	branchName: string | null
	error?: string
}

const BranchCodeInput = ({ register, branchName, error }: Props) => {
	return (
		<div className={styles.field}>
			<label className={styles.label}>支店コード</label>
			<div className={styles.code_input_row}>
				<input
					type="text"
					maxLength={3}
					placeholder="001"
					className={`${styles.input} ${styles.code_input} ${error ? styles.input_error : ""}`}
					{...register}
				/>
				<span className={styles.lookup_name}>
					{branchName === null ? "" : branchName || "該当なし"}
				</span>
			</div>
			{error && <span className={styles.error_message}>{error}</span>}
		</div>
	)
}

export default BranchCodeInput
